import { render, staticRenderFns } from "./RecommendInfo.vue?vue&type=template&id=6000641a&scoped=true&"
import script from "./RecommendInfo.vue?vue&type=script&lang=js&"
export * from "./RecommendInfo.vue?vue&type=script&lang=js&"
import style0 from "./RecommendInfo.vue?vue&type=style&index=0&id=6000641a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000641a",
  null
  
)

export default component.exports